<template>
  <div>
    <b-list-group
      class="border-primary"
    >
      <b-list-group-item
        v-for="(value, name) in desc_list"
        :key="name"
        class="d-flex w-100 justify-content-between align-items-center"
      >
        <small class="text-secondary text-uppercase">{{ $t(`${module_prefix}.${name}`) }}</small>
        <a
          v-if="name === 'site'"
          class="cursor-pointer text-primary"
          @click="proceedToUrl(value)"
        >
          {{ $t('objects.proceed') }}
        </a>
        <h5
          v-else-if="value && typeof value === 'string'"
          class="font-weight-bold"
        >
          {{ value }}
        </h5>
        <ul v-else-if="value && typeof value === 'object' && value.length">
          <li
            v-for="(item, index) in value"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
        <h6
          v-else
          class="text-muted"
        >
          {{ $t('references.not_indicated') }}
        </h6>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  components: {
    BListGroup,
    BListGroupItem,
  },
  props: {
    desc_list: {
      type: Object,
      required: true,
    },
    module_prefix: {
      type: String,
      required: true,
    },
  },
  methods: {
    proceedToUrl(url) {
      if (url.startsWith('http')) {
        window.open(url)
      } else {
        window.open(`http://${url}`)
      }
    },
  },
}
</script>

<style>

</style>
